
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/star",
      function () {
        return require("private-next-pages/star.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/star"])
      });
    }
  